import React, { Component } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';

import SignUp from './containers/SignUp';

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            shrinked: false
        };

        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleScroll);
    }

    handleScroll(event) {
        var last_known_scroll_position =
            typeof window.scrollY === "undefined"
                ? window.pageYOffset
                : window.scrollY;
        if (last_known_scroll_position > 100) {
            this.setState({ shrinked: true });
        } else {
            if (window.innerWidth <= 991) {
                this.setState({ shrinked: true });
            } else {
                this.setState({ shrinked: false });
            }
        }
    }

    render() {
        return (
            <Switch>

                <Route
                    exact
                    path='/'
                    render={() => <SignUp shrinked={this.state.shrinked} />} />

                <Redirect to='/' />
            </Switch>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js